exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".touyide[data-v-21227704]{height:68px;margin-top:20px;display:flex}.touxiang[data-v-21227704]{width:68px;height:68px;border-radius:34px;margin-left:20px}.xuexitou[data-v-21227704]{margin-top:20px;height:50px;width:100%;background:#add8e6}.biaoxiang[data-v-21227704]{width:336px;height:50px;display:flex;margin:0 auto}.xiaotanyi[data-v-21227704]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.xiaotaner[data-v-21227704],.xiaotansan[data-v-21227704],.xiaotanyi[data-v-21227704]{width:112px;height:50px;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-21227704","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Modular/menu/PersonalCenter/Learningrecord.vue
// module id = 569
// module chunks = 0